import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';

import '@/assets/styles/global.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebookF, faTwitter, faInstagram, faYoutube, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';
import nl from './locales/nl.json';

library.add(faFacebookF, faTwitter, faInstagram, faYoutube, faLinkedinIn);

const savedLanguage = localStorage.getItem('userLanguage') || 'pt';

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    pt: pt,
    en: en,
    es: es,
    nl: nl,
  },
});

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.use(i18n);
app.mount('#app');

